import { Icon } from '@driftt/tide-icons'
import React from 'react'
import { useState } from 'react'

import styles from './styles.module.css'

interface CollapsibleContentProps {
  children: React.ReactNode
  title: string
  expandedByDefault?: boolean
}

const CollapsibleContent: React.ElementType<CollapsibleContentProps> = ({
  children,
  title,
  expandedByDefault = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(expandedByDefault)

  return (
    <>
      <div
        className={styles.collapsibleTitle}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? (
          <Icon width="10" name="chevron-down" />
        ) : (
          <Icon height="10" name="arrow-1-right" />
        )}
        {title}
      </div>
      {isExpanded && children}
    </>
  )
}

export default CollapsibleContent
